/**
 * Intersects `[start, end]` with `[domainStart, domainEnd]`. Returns `null` if empty.
 */
export function clampTimeRangeToDomain(
  start: Date,
  end: Date,
  domainStart: Date,
  domainEnd: Date,
): { start: Date; end: Date } | null {
  const s = Math.max(start.getTime(), domainStart.getTime());
  const e = Math.min(end.getTime(), domainEnd.getTime());
  if (!(e > s)) {
    return null;
  }
  return { start: new Date(s), end: new Date(e) };
}
